/* eslint-disable max-len */
import React from 'react';
import { LFC } from '../../Legacy';
import { Fill } from '../../ui/Fill';
import { UseLocationScope } from '../AppLocation';
import { useResolve } from '../Container';
import { AccountHeaderBlock } from '../account/AccountHeaderBlock';
import { AccountModel } from '../account/AccountModel';
import { PlanStateHeaderBlock } from '../account/PlanStateHeaderBlock';
import { Crumbs } from '../common/Crumbs';
import { Page } from '../common/Page';
import { ButtonStrip, Copy, Flexer, LinkButton, Spacer, Title } from '../dashboard/elements/LayoutElements';
import { Colors } from './../../ui';

const ManageDangerZoneLayout: LFC<{ param?: string }> = ({ param }) => {

    const account = useResolve(AccountModel);

    return <Fill flex="column">
        <Flexer flex="column" grow align="center" padding="10 0">
            <Flexer flex width="32" padding="1.5" border={`solid .125rem ${Colors.border}`} borderRadius=".375">
                <Title>Do you want to delete your team?</Title>
                <Spacer />
                <Copy>
                    If you are done with Ludi and want to delete your team and all your data, you can do that here.
                    Click the button below to start the process (you&apos;ll be asked to confirm again first).  If not, better
                    get out of here!
                </Copy>
                <Spacer f={1} />
                <ButtonStrip>
                    <LinkButton href={`/delete/${account.id}`} variant="negative">Delete {account.label}</LinkButton>
                    <LinkButton to="~/manage">Go Back</LinkButton>
                </ButtonStrip>
            </Flexer>
        </Flexer>
    </Fill>;
};

export const ManageDangerZoneView: LFC<{ param?: string }> = (props) => {
    return <>
        <UseLocationScope name="users" label="People" />
        <Page.Header>
            <Crumbs items={[
                ['Manage', '/manage'],
                ['Danger Zone', null],
            ]} />
            <Page.HeaderPush>
                <PlanStateHeaderBlock />
                <AccountHeaderBlock />
            </Page.HeaderPush>
        </Page.Header>
        <Page.Content>
            <ManageDangerZoneLayout {...props} />
        </Page.Content>
    </>;
};

